import React, { Fragment } from 'react';

import { AuthCompanyContext } from '@homesusa/auth';
import { Company } from '@homesusa/core';
import { ButtonGroupStyled, buttonGroupClasses } from './header-user.style';
import { useAnchorEl } from './use-anchor-el';
import { CompanyButtonMenu, CompanyButton } from './company-button.component';
import { MarketButton, MarketButtonMenu } from './market-select.component';
import { ProfileButton, ProfileButtonMenu } from './profile-button.component';

export function HeaderUserCompanies(): JSX.Element {
  const { userCompanies, currentMarket } = React.useContext(AuthCompanyContext);
  const anchorCompanies = useAnchorEl();
  const anchorMarket = useAnchorEl();
  const anchorUser = useAnchorEl();

  const markets = React.useMemo(() => {
    return userCompanies
      ? userCompanies.reduce((rv: Record<string, Company[]>, company) => {
          (rv[company.marketCode] = rv[company.marketCode] || []).push(company);
          return rv;
        }, {})
      : {};
  }, [userCompanies]);

  if (!userCompanies) {
    return <Fragment></Fragment>;
  }

  return (
    <div>
      <ButtonGroupStyled aria-label='company user menu' className={buttonGroupClasses.root}>
        <MarketButton anchor={anchorMarket} />
        <CompanyButton anchor={anchorCompanies} />
        <ProfileButton anchor={anchorUser} />
      </ButtonGroupStyled>
      <MarketButtonMenu markets={markets} anchor={anchorMarket} />
      <CompanyButtonMenu companies={markets[currentMarket]} anchor={anchorCompanies} />
      <ProfileButtonMenu anchor={anchorUser} />
    </div>
  );
}
